var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTvAerialPoint01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3,3c2.6-0.1,4.9,1.9,5,4.5c0,0.2,0,0.3,0,0.5c0,2.8-2.3,5-5,5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 8.1,
    y1: 8,
    x2: 13,
    y2: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13,6.4c-0.2,0.2-2,1.5-2,1.6c0.6,0.6,1.3,1.1,2,1.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvAerialPoint01);
export default __webpack_public_path__ + "static/media/TVAerialPoint-01.ef55e6eebef2e653f85fd77ab8738f02.svg";
export { ForwardRef as ReactComponent };